/** Shape: 1f8b2bcfff00 */
export const getRandom12digitsAlphaNum = (): string =>
  Math.floor((1 + Math.random()) * Number.MAX_SAFE_INTEGER)
    .toString(16)
    .substring(2);
